/**
 * Created by Qingger Corp.
 * User: yangzihua
 * Date: 2019/6/17
 * Time: 20:45
 * Desc: 云店设置-分类配置-快捷图标配置
 */

import { Component, Vue } from 'vue-property-decorator';
import type { ElForm } from 'element-ui/types/form';
import { IPSService } from '@/services/ipsServices';
import { appEnvConfig } from '@/configs/appConfigs';
import { QinggerLibUtils } from '@/util';
import baseAPIService from '@/services/base/baseAPIService';
import { EmpServiceAPIActions } from '@/services/empService';
import { Functions } from '@/library/utils/functions';
const isset = QinggerLibUtils.isset;

@Component
export default class IconCategory extends Vue {
  /* 数据 */

  /**
   * corpId
   */
  public corpId = baseAPIService.resolveCorpId();

  /**
   * loading状态
   * @type {boolean}
   */
  public loadingState = false;

  /**
   * 标签分类列表
   * @type {Array<ProductClassInfo>}
   */
  public labelClassList: Array<ProductClassInfo> = [];

  /**
   * 绑定主档分类弹窗是否显示
   * @type {boolean}
   */
  public isBindMainVisible = false;

  /**
   * 关联分类：已选中的下拉标签
   * @type {ItemArray<RelationClass>}
   */
  public selectConnectedClass: ItemArray<RelationClass> = [];

  /**
   * 关联分类：下拉标签
   * @type {ItemArray<RelationClass>}
   */
  public connectedClass: ItemArray<RelationClass> = [];

  /**
   * 选择的标签对应的属性列表
   * @type {any[]}
   */
  public connectedClassSelected: ItemArray<any> = [];

  /**
   * 选择关联的属性
   * @type {ItemObject}
   */
  public attrSelected: ItemObject = {
    classId: 0,
    attrList: [],
  };

  /**
   * 关联分类 标签选择限制
   * @type {number}
   */
  public limitNum = 6;

  /**
   *  图片上传地址
   *  @type {string}
   */
  public imgTpConfig = `${Functions.ipsHostUrlApi()}/pic/upload/withOut/key`;

  /**
   * 图片放大弹窗是否显示
   * @type {boolean}
   */
  public isMagnifyPopShow = false;

  /**
   * 添加快捷图标弹窗是否显示
   * @type {boolean}
   */
  public isAddIconVisible = false;

  /**
   * 新增标签分类/编辑
   * @type {string}
   */
  public theTitle = '';

  /**
   *  待新建/编辑的标签分类
   * @type {ProductClassInfo}
   */
  public labelData: ProductClassInfo = {};

  /**
   * 分类状态默认启用
   * @type {number}
   */
  public defaultSta = 1;

  /**
   * 上传的图标地址
   * @type {string}
   */
  public uploadPic = '';

  /**
   * 图片上传地址
   * @type {string}
   */
  public fileTpConfig = `${Functions.ipsHostUrlApi()}/pic/upload/withOut/key`;

  /**
   * token
   * @type {{Authorization: string}}
   */
  public tokenData: ItemObject = {
    Authorization: `Bearer ${EmpServiceAPIActions.getTokenFromCache().token}`,
  };

  /**
   * 错误图片
   */
  public errorImg: any = require('../../../../static/img/boxBgImg.svg');

  /* 方法 */

  /**
   * 获取标签分类列表
   */
  public getLabelClassList(): void {
    const queryParams = {
      sgId: this.$route.params.id,
    };
    IPSService.getLabelClassList({ queryParams }).then((res) => {
      this.labelClassList = res.list;
    });
  }

  /**
   * 绑定主档分类弹窗
   * @param {ItemObject} row
   * @return null
   */
  public onBindMainVisible(row: ItemObject): void {
    this.isBindMainVisible = true;
    this.attrSelected.classId = row.classId;
    this.attrSelected.attrList = row.relationList;
    this.selectConnectedClass = [];
    if (row.relationList.length > 0) {
      const selected = row.relationList.map(item => item.attrCode); // 获取已关联分类
      const all = this.connectedClass.map(item => item.attrCode); // 所有
      this.selectConnectedClass = selected.filter((item) => {
        return all.includes(item);
      });
    }
    this.selectClassChange();
  }

  /**
   * 重新格式化图片地址
   * @param {ItemObject} item
   */
  public reCreateImgSrc(item: ItemObject): void {
    item.iconSrc = this.errorImg;
  }

  /**
   * 图片上传之前
   * @param {ItemObject} file
   * @return boolean
   */
  public onBeforeUpload(file: ItemObject): boolean {
    const isJpg = file.type === 'image/jpeg';
    const isPng = file.type === 'image/png';
    const isGif = file.type === 'image/gif';
    const LtSize = file.size / 1024 <= 300;
    if (!isJpg && !isPng && !isGif) {
      this.$message.error('上传图片只能是 JPG/JPEG/PNG/GIF 格式!');
    }
    if (!LtSize) {
      this.$message.error('上传图片大小不能超过 300Kb!');
    }
    return (isJpg || isPng || isGif) && LtSize;
  }

  /**
   * 图片放大
   * @return null
   */
  public onMagnifyPic(): void {
    this.isMagnifyPopShow = true;
  }

  /**
   * 图片放大弹窗
   * @return null
   */
  public onScaleTableShow(): void {
    this.isAddIconVisible = true;
  }

  /**
   * 图片放大弹窗
   * @param {string} pic
   * @return null
   */
  public onMagnifyClassPic(pic: string): void {
    this.uploadPic = pic;
    this.isMagnifyPopShow = true;
  }

  /**
   * 删除分类
   * @param classId
   * @param type
   * @return null
   */
  public onDeleteClass(classId, type): void {
    this.$confirm('是否删除此标签分类?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then(() => {
      const postParams = {
        classIdList: [classId],
        classState: type,
      };
      IPSService.batchOperationClass({ postParams }).then((res) => {
        if (res.ret) {
          this.$message.success('删除成功');
          this.getLabelClassList();
        } else {
          this.$message.error('删除失败');
        }
      });
    });
  }

  /**
   * 禁用/启用 操作
   * @param classId
   * @param type
   */
  public onOperationClass(classId, type) {
    const postParams = {
      classIdList: [classId],
      classState: type,
    };
    IPSService.batchOperationClass({ postParams }).then((responseData) => {
      if (responseData.ret) {
        this.$message.success('操作成功');
        this.getLabelClassList();
      } else {
        this.$message.error('操作失败');
      }
    });
  }

  /**
   * 失去焦点
   * @param value
   */
  public onSortBlur(value) {
    const postParams = {
      classId: value.classId,
      classSort: value.classSort,
    };
    IPSService.updateClassSort({ postParams }).then((res) => {
      if (res.ret) {
        this.$message.success('设置成功');
        this.getLabelClassList();
      } else {
        this.$message.error('设置失败');
      }
    });
  }

  /**
   * 提交关联分类/绑定主档分类
   * @return null
   */
  public onSubmitRelated(): void {
    if (this.attrSelected.attrList.length < 1) {
      this.$message.warning('请选择分类');
      return;
    }
    const postParams = this.attrSelected;
    IPSService.relateAttributeOfClass({ postParams }).then((res) => {
      if (res.ret) {
        this.$message.success('绑定成功');
        this.isBindMainVisible = false;
        this.getLabelClassList();
      } else {
        this.$message.error('绑定失败');
      }
    });
  }

  /**
   * 选中的关联分类发生变化时
   */
  public selectClassChange(): void {
    const self = this;
    const selected = this.connectedClass.filter((item) => {
      // @ts-expect-error
      return self.selectConnectedClass.includes(item.attrCode);
    });

    self.connectedClassSelected = [];
    selected.forEach(
      (el) => {
        /* 查询是否被选中 */
        const attrCode = el.attrCode;
        const selected = self.attrSelected.attrList.filter((item) => {
          return item.attrCode == attrCode; // 返回已选择类
        });
        let selectValues = [];
        if (selected.length > 0) {
          const selectValueList = selected[0].attrValues.split(','); // 获取已选子分类
          const valueList = el.list.map(item => item.value_no); // 所有子分类
          selectValues = selectValueList.filter((item) => {
            return valueList.includes(item); // 返回在子分类中存在的已选择值
          });
        }
        const checkedCount = selectValues.length;
        const checkAll = checkedCount === el.list.length;
        const isIndeterminate = checkedCount > 0 && checkedCount < el.list.length;
        el = Object.assign({}, el, {
          checkAll,
          selectValues,
          isIndeterminate,
        });
        self.connectedClassSelected.push(el);
      },
    );
    self.changeAttrSelected();
  }

  /**
   * 获取关联分类
   */
  public getAttributeList(): void {
    IPSService.getAttributeList().then((res) => {
      if (isset(res, 'list')) {
        this.connectedClass = res.list;
      }
    });
  }

  /**
   * 根据选中值更改attrSelected
   */
  public changeAttrSelected(): void {
    const self = this;
    const selected = self.connectedClassSelected.filter((item) => {
      return item.selectValues.length > 0;
    });
    self.attrSelected.attrList = [];
    selected.forEach(
      (el) => {
        /* 查询是否被选中 */
        const attr = {
          attrCode: el.attrCode,
          attrName: el.attrName,
          attrValues: el.selectValues.join(','),
        };
        self.attrSelected.attrList.push(attr);
      },
    );
  }

  /**
   * 选择类型
   * @param value
   */
  public onHandleCheckedCitiesChange(value): void {
    const checkedCount = value.selectValues.length;
    value.checkAll = checkedCount === value.list.length;
    value.isIndeterminate = checkedCount > 0 && checkedCount < value.list.length;
    this.changeAttrSelected();
  }

  /**
   * 点击全选按钮
   * @param value
   */
  public onHandleCheckAllChange(value): void {
    const valueList = value.list.map(item => item.value_no); // 所有子分类
    value.selectValues = value.checkAll ? valueList : [];
    value.isIndeterminate = false;
    this.changeAttrSelected();
  }

  /**
   * 编辑快捷图标
   * @param {ItemObject} row
   * @return null
   */
  public onEditeClass(row: ItemObject): void {
    this.isAddIconVisible = true;
    this.theTitle = '编辑快捷图标';
    this.labelData = JSON.parse(JSON.stringify(row));
    this.defaultSta = row.classState;
    this.uploadPic = row.classPic;
  }

  /**
   * 清除表单数据
   * @return null
   */
  public onClearForm(): void {
    if (this.theTitle === '添加快捷图标') {
      (this.$refs.lableForm as ElForm).resetFields();
    }
    this.uploadPic = '';
    this.isAddIconVisible = false;
  }

  /**
   * 新增标签分类
   * @return null
   */
  public onAddLabelClass(): void {
    this.uploadPic = '';
    this.labelData = {};
    this.isAddIconVisible = true;
    this.labelData.classId = 0;
    this.labelData.classState = this.defaultSta;
    this.labelData.classSort = this.labelClassList.length + 1;
    this.theTitle = '添加快捷图标';
    (this.$refs['lableForm'] as ElForm).resetFields(); // 防止验证报错
  }

  /**
   * 删除已上传的图片
   * @return null
   */
  public onDeletePic(): void {
    this.uploadPic = '';
    this.labelData.classPic = '';
  }

  /**
   * 图片上传成功时的处理
   * @param res
   * @param file
   */
  public uploadImgSuccess(res: HttpAPIRetItem<any>, file: any) {
    this.uploadPic = res.content;
    this.labelData.classPic = res.content;
  }

  /**
   * 图片上传失败
   * @return null
   */

  public uploadImgError() {
    this.$message.error('图片上传失败');
  }

  /**
   * 更新标签分类
   * @return null
   */
  public onUpdateTheLabel(): void {
    const postParams = {
      classState: this.defaultSta,
      classPic: this.labelData.classPic,
      classSort: this.labelData.classSort,
      className: this.labelData.className,
      classId: this.labelData.classId,
      sgId: Number.parseInt(this.$route.params.id),
    };
    (this.$refs['lableForm'] as ElForm).validate((valid) => {
      if (valid) {
        IPSService.updateLabelClass({ postParams }).then((res) => {
          if (res.ret) {
            this.$message.success('设置成功');
            this.isAddIconVisible = false;
            this.getLabelClassList();
          } else {
            this.$message.error('设置失败');
          }
        });
      }
    });
  }

  /* 周期 */

  /**
   * 当组建创建时
   */
  public created() {
    this.getLabelClassList(); // 获取标签分类列表
    this.getAttributeList(); // 获取关联分类
  }
}
